export default __webpack_public_path__ + "static/media/card-w-service@3x.bf044f62.png";